<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Banner设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          :value="query.type"
          @change="handleQueryChange('type', $event)"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in bannerTypes"
            :key="item.type"
            :label="item.message"
            :value="item.type"
          ></el-option>
        </el-select>
        <el-select
          :value="query.language"
          @change="handleQueryChange('language', $event)"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in languageList"
            :key="item.intCode"
            :label="item.language"
            :value="item.intCode"
          ></el-option>
        </el-select>
        <el-select
          :value="query.tenantId"
          @change="handleQueryChange('tenantId', $event)"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in tentIdlist"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          :value="query.platform"
          @change="handleQueryChange('platform', $event)"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in platformTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          :value="query.subjectType"
          @change="handleQueryChange('subjectType', $event)"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in subjectTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <create-banner @refresh="refreshList"></create-banner>
      </div>
      <banner-list @refresh="refreshList"></banner-list>
    </el-card>
  </div>
</template>

<script>
import './store'
import BannerList from './components/list'
import CreateBanner from './components/create'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'BannerSetting',
  components: {
    BannerList,
    CreateBanner,
  },
  computed: {
    ...mapState('settingBanner', [
      'platformTypeList',
      'subjectTypeList',
      'languageList',
      'query',
      'bannerTypes',
      'tentIdlist',
    ]),
  },
  methods: {
    ...mapActions('settingBanner', [
      'list',
      'getbannerType',
      'getTentIdlist',
      'getLanguageList',
    ]),
    ...mapMutations('settingBanner', ['changeQuery']),
    refreshList() {
      this.list(this.query)
    },
    handleQueryChange(type, value) {
      this.changeQuery({
        ...this.query,
        [type]: value,
      })
      this.refreshList()
    },
  },
  created() {
    this.list(this.query)
    this.getbannerType()
    this.getTentIdlist()
    this.getLanguageList()
  },
}
</script>

<style lang="less" scoped></style>
